import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setToken(token) {
  if (token) {
    localStorage.setItem("scc_token", token);
  } else {
    localStorage.removeItem("scc_token");
  }
}

export function getToken() {
  return localStorage.getItem("scc_token");
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    const contentType = r.headers?.["content-type"] || "";
    if (r.config?.url?.startsWith("/") && contentType.includes("text/html")) {
      return Promise.reject(new Error("The SIX9 API is not configured for this deployment yet."));
    }
    return r;
  },
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes("/auth/")) {
      setToken(null);
      if (!window.location.pathname.match(/^\/(login|signup|forgot-password|reset-password|)$/)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || fallback;
}
